module.exports = __webpack_public_path__ + "static/thumbnail-m-9368f85dfab3057e503777997c8fd3f9.png";